"use client"

import React from 'react'
import { useMobileContext } from './MobileContext'
import { Card, Typography, Image } from 'antd'
import { useTranslation } from 'react-i18next'

const { Title } = Typography

const Pricing: React.FC = () => {
  const isMobile = useMobileContext()
  const { t } = useTranslation()

  return (
    <Card className={!isMobile ? 'p-6' : 'p-2'}>
      <Title level={2}>{t("esim.rates_content_title")}</Title>
      
      <div className="w-full flex justify-center mt-4">
        <Image
          src="/static/images/esim/esim.jpg"
          alt="eSIM quốc tế"
          width="100%"
          preview={{
            cover: <div className="text-center">{t("common.see_detail")}</div>,
          }}
          className="rounded shadow-md"
        />
      </div>
    </Card>
  )
}

export default Pricing